import { createFileRoute } from '@tanstack/react-router'
import Categories from '@/components/Categories'

export const Route = createFileRoute('/_authenticated/products/categories/')({
  component: CategoryManagement,
})

function CategoryManagement() {
  return <Categories />
}
